<script setup lang="ts">

  defineProps({
    header: String,
    header_type: String,
    content: String,
    photos: Array,
  });
</script>
<template>
  <section class="text-photo ">
    <div class="text-photo__content section-wrapper container">
      <SegmentHeading larger :type="header_type || 'h2'" class="text-photo__header">
        {{ header }}
      </SegmentHeading>
      <MediaPicture :photo="photos" type="photo" class="text-photo__image" sizes="1984x1488 2x max 992,992x744 max 992,1400x1050 2x, 700x525" />
      <div class="section-typography" v-html="content" />
    </div>
  </section>
</template>
<style scoped lang="scss">
  .text-photo {

    &__content::after {
      content: '';
      clear: both;
    }

    &__header {
      margin-bottom: 2.5rem;

      &::after {
        display: none;
      }
    }

    :deep(.text-photo__image) {
      float: right;
      width: 50%;
      margin: 0 0 1rem 2.5rem;

      img {
        object-fit: cover;
      }
    }
  }

  @media (max-width: 992px) {
    .text-photo {
      display: flex;
      flex-direction: column;
      padding: 0 1rem;

      &__content{
        display: flex;
        flex-direction: column;
        gap:  1rem;
      }

      &__header {
        margin-bottom: 0;
        font-size: 1.5rem;
      }

      :deep(.text-photo__image) {
        float: none;
        width: 100%;
        margin: 1rem 0 0 0;
        order: 3;
      }
    }
  }
</style>
